import funciones from "./funcion/funcionSINOJ";
import sistema from "./sistema/sistemaSINOJ";
import catalogos from "./catalogos/catalogosSINOJ";

const sinoj = {
  sistema: sistema,
  catalogos: catalogos,
  funciones: funciones
}

export default sinoj



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/sinojapi.js
// module id = null
// module chunks = 